/*
 * Copyright (c) 2021.
 * This file is part of the Compo B2B application.
 * (c) Compo soft - Vladimir Ganturin <gun2rin@gmail.com>
 * For the full copyright and license information, please view the LICENSE
 * file that was distributed with this source code.
 */

export enum WidgetType {
  SIMPLE_TABLE,
  PIVOT_TABLE,
  LINEAR_CHART,
  PRODUCT_ELASTICSEARCH,
  ORDER_SUMMARY,
  ORDER_COUNT,
  USERS,
  ECOMMERCE_INFO,
  ORDER_COUNT_AVG
}
